import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Button,
  TextArea
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardDrugCounsellingUX = (props: any) => {
    return(
      <div
        id="CardDrugCounsellingUX-div-0">
        <div
          id="CardDrugCounsellingUX-div-1"
          style={{padding: "20px", display: "flex", flexDirection: "column"}}>
          
          <div
            id="CardDrugCounsellingUX-div-2"
            style={{padding:"20px 20px", fontSize: "20px", fontWeight: "bold", color: "#1b75bb"}}>
            {props.languageUX === "en" ? "Drug counseling history" : "ประวัติการให้คำปรึกษาการใช้ยา"}
          </div>
          <div
            className="ui form"
            id="CardDrugCounsellingUX-div-3">
            
            <FormGroup
              id="CardDrugCounsellingUX-FormGroup-8"
              inline={true}>
              <FormField
                id="CardDrugCounsellingUX-FormField-10"
                inline={true}
                width={2}>
                <div
                  id="CardDrugCounsellingUX-div-18">
                  {props.languageUX === "en" ? "Consultation date" : "วันที่ให้คำปรึกษา"}
                </div>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-11"
                inline={true}
                width={2}>
                <div
                  id="CardDrugCounsellingUX-div-26"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardDrugCounsellingUX-DateTextBox-28"
                    onChange={(date: any) => {props.onChange("filterStartDate", date)}}
                    style={{width: "100%"}}
                    value={props.filterStartDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-12">
                <div
                  id="CardDrugCounsellingUX-div-21">
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </div>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-13"
                inline={true}
                width={2}>
                <div
                  id="CardDrugCounsellingUX-div-29"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardDrugCounsellingUX-DateTextBox-30"
                    onChange={(date: any) => {props.onChange("filterEndDate", date)}}
                    style={{width: "100%"}}
                    value={props.filterEndDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-14"
                inline={true}
                width={1}>
                <div
                  id="CardDrugCounsellingUX-div-22">
                  {props.languageUX === "en" ? "section" : "หัวข้อ"}
                </div>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-15"
                inline={true}
                width={3}>
                <Input
                  id="CardDrugCounsellingUX-Input-24"
                  onChange={(e:any, data: any) => {props.onChange("filterTitle", data.value)}}
                  value={props.filterTitle}>
                </Input>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-16"
                inline={true}
                width={2}>
                <div
                  id="CardDrugCounsellingUX-div-23">
                  {props.languageUX === "en" ? "Consultant" : "ผู้ให้คำปรึกษา"}
                </div>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-17"
                inline={true}
                width={3}>
                <div
                  id="CardDrugCounsellingUX-div-25"
                  style={{width: "100%"}}>
                  {props.advisorSearch}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardDrugCounsellingUX-FormGroup-9">
              <FormField
                id="CardDrugCounsellingUX-FormField-31"
                inline={true}
                width={13}>
              </FormField>
              <FormField
                id="CardDrugCounsellingUX-FormField-32"
                inline={true}
                width={3}>
                <div
                  id="CardDrugCounsellingUX-div-33"
                  style={{display: "flex", justifyContent: "space-evenly"}}>
                  
                  <Button
                    color="blue"
                    id="CardDrugCounsellingUX-Button-34"
                    onClick={props.onSearch}>
                    {props.languageUX === "en" ? "Search" : "ค้นหา"}
                  </Button>
                  <Button
                    color="green"
                    id="CardDrugCounsellingUX-Button-35"
                    onClick={props.onAddItem}>
                    {props.languageUX === "en" ? "Add item" : "เพิ่มรายการ"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardDrugCounsellingUX-div-4"
            style={{height: "275px"}}>
            
            <Table
              data={props.drugCounsellingList}
              defaultPageSize={5}
              headers="วันที่ให้คำปรึกษา,หัวข้อ,รายละเอียดการให้คำปรึกษา,ผู้ให้คำปรึกษา,แก้ไข/ลบ"
              id="CardDrugCounsellingUX-Table-36"
              keys="date,title,description,advisor_name,_action"
              minRows={5}
              pageSize={5}
              showPagination={false}
              style={{height: "270px"}}
              widths="200,300,,200,150">
            </Table>
          </div>
          <div
            id="CardDrugCounsellingUX-div-5">
            {props.pagination}
          </div>
          <div
            id="CardDrugCounsellingUX-div-6"
            style={{padding: "10px", border: "1px solid #1b75bb", borderRadius: "10px", display: props.showDetail? "": "none"}}>
            
            <div
              id="CardDrugCounsellingUX-div-54">
              {props.closeIcon}
            </div>
            <div
              id="CardDrugCounsellingUX-div-37"
              style={{display: "flex", alignItems: "center"}}>
              
              <div
                id="CardDrugCounsellingUX-div-41"
                style={{padding: "5px"}}>
                {props.languageUX === "en" ? "Consultation date" : "วันที่ให้คำปรึกษา"}
              </div>
              <div
                id="CardDrugCounsellingUX-div-42">
                
                <DateTextBox
                  id="CardDrugCounsellingUX-DateTextBox-45"
                  onChange={(date: string) => {props.onChange("adviseDate", date)}}
                  style={{width: "100%"}}
                  value={props.adviseDate}>
                </DateTextBox>
              </div>
              <div
                id="CardDrugCounsellingUX-div-43"
                style={{padding: "5px"}}>
                {props.languageUX === "en" ? "section" : "หัวข้อ"}
              </div>
              <div
                id="CardDrugCounsellingUX-div-44"
                style={{width:"60%"}}>
                
                <Input
                  id="CardDrugCounsellingUX-Input-46"
                  onChange={(e:any, data: any) => {props.onChange("title", data.value)}}
                  style={{width: "100%"}}
                  value={props.title}>
                </Input>
              </div>
            </div>
            <div
              id="CardDrugCounsellingUX-div-38"
              style={{padding: "10px 5px"}}>
              {props.languageUX === "en" ? "Consultation details" : "รายละเอียดการให้คำปรึกษา"}
            </div>
            <div
              id="CardDrugCounsellingUX-div-39"
              style={{paddingRight: "10px"}}>
              
              <TextArea
                id="CardDrugCounsellingUX-TextArea-47"
                onChange={(e:any, data: any) => {props.onChange("description", data.value)}}
                rows="5"
                style={{resize: "none", width: "100%"}}
                value={props.description}>
              </TextArea>
            </div>
            <div
              id="CardDrugCounsellingUX-div-40"
              style={{padding: "10px 5px", display: "flex",  justifyContent: "flex-end", alignItems: "center"}}>
              
              <div
                id="CardDrugCounsellingUX-div-48"
                style={{padding: "5px"}}>
                {props.languageUX === "en" ? "Consultant" : "ผู้ให้คำปรึกษา"}
              </div>
              <div
                id="CardDrugCounsellingUX-div-49">
                {props.advisorCode}
              </div>
              <div
                id="CardDrugCounsellingUX-div-50">
                {props.saveButton}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardDrugCounsellingUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการให้คำปรึกษาการใช้ยา",
          "valueEN": "Drug counseling history"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"20px 20px\", fontSize: \"20px\", fontWeight: \"bold\", color: \"#1b75bb\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{height: \"275px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", border: \"1px solid #1b75bb\", borderRadius: \"10px\", display: props.showDetail? \"\": \"none\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormGroup-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ให้คำปรึกษา",
          "valueEN": "Consultation date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "หัวข้อ",
          "valueEN": "section"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ให้คำปรึกษา",
          "valueEN": "Consultant"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Input",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-Input-24"
        },
        "onChange": {
          "type": "code",
          "value": "(e:any, data: any) => {props.onChange(\"filterTitle\", data.value)}"
        },
        "value": {
          "type": "code",
          "value": "props.filterTitle"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.advisorSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 28,
      "name": "DateTextBox",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-DateTextBox-28"
        },
        "onChange": {
          "type": "code",
          "value": "(date: any) => {props.onChange(\"filterStartDate\", date)}"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterStartDate"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 30,
      "name": "DateTextBox",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-DateTextBox-30"
        },
        "onChange": {
          "type": "code",
          "value": "(date: any) => {props.onChange(\"filterEndDate\", date)}"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterEndDate"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-evenly\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Button",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-Button-34"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรายการ",
          "valueEN": "Add item"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-Button-35"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddItem"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 36,
      "name": "Table",
      "parent": 4,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugCounsellingList"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "5"
        },
        "headers": {
          "type": "value",
          "value": "วันที่ให้คำปรึกษา,หัวข้อ,รายละเอียดการให้คำปรึกษา,ผู้ให้คำปรึกษา,แก้ไข/ลบ"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-Table-36"
        },
        "keys": {
          "type": "value",
          "value": "date,title,description,advisor_name,_action"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "pageSize": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"270px\"}"
        },
        "widths": {
          "type": "value",
          "value": "200,300,,200,150"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการให้คำปรึกษา",
          "valueEN": "Consultation details"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"10px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px\", display: \"flex\",  justifyContent: \"flex-end\", alignItems: \"center\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ให้คำปรึกษา",
          "valueEN": "Consultation date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-42"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "หัวข้อ",
          "valueEN": "section"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{width:\"60%\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 45,
      "name": "DateTextBox",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-DateTextBox-45"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string) => {props.onChange(\"adviseDate\", date)}"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.adviseDate"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Input",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-Input-46"
        },
        "onChange": {
          "type": "code",
          "value": "(e:any, data: any) => {props.onChange(\"title\", data.value)}"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.title"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "TextArea",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-TextArea-47"
        },
        "onChange": {
          "type": "code",
          "value": "(e:any, data: any) => {props.onChange(\"description\", data.value)}"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "style": {
          "type": "code",
          "value": "{resize: \"none\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.description"
        }
      },
      "seq": 47,
      "void": true
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ให้คำปรึกษา",
          "valueEN": "Consultant"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.advisorCode"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.saveButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.closeIcon"
        },
        "id": {
          "type": "value",
          "value": "CardDrugCounsellingUX-div-54"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 37,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugCounsellingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 75
}

*********************************************************************************** */
